import React from "react";
import SeoForm from "./components/SeoForm";

function AddStaticSeo() {
  return <SeoForm entityType="static-page" />;
}

export default AddStaticSeo;
